import * as $ from 'jquery';

export class moreLinks {
    $scope:any                  = $('#more-links--container');
    $scopeMob:any               = $('#mob-more-links--container');
    
    nav(): void {
		let _self = this;
		let $checkIn:any         = $('#check-in--container');
		let $viewBooking:any     = $('#view-booking--container');
		let $flightStatus:any    = $('#flight-status--container');
		let $login:any           = $('#login-container');
		let $loggedin:any        = $('#logged-in-user-menu');
		let $checkInMob:any      = $('#mob-checkin--container');
		let $viewBookingMob:any  = $('#mob-viewbooking--container');
		let $flightStatusMob:any = $('#mob-flightstatus--container');
		let $loginMob:any        = $('#mob-login--container');
		let $loggedinMob: any    = $('#mob-logged-in-user-menu');
		let $mhStay: any         = $('#ibe-stay--container');
		let $mhUpgrade: any      = $('#mhupgrade-in--container');
        let $mholidays: any 	 = $('#mholiday-ibe--container');
        let $bookingWidget: any  = $('#book-flight--container');
		let $flightupgradeMob: any 	 = $('#mob-flightupgrade--container');
		let $flightUpgrade : any = $('#view-upgrade');
		let $enrichHotel:any         = $('#enrich-hotels-container');
		let $enrichHotelMob:any      = $('#mob-enrich-hotels-container');
		let $ibeNav:any;
		if($('.ibe-refresh').length >0) {
			$ibeNav    = $('.desktop #bookingNav');
		}
		else {
			$ibeNav    = $('#bookingNav');
		}
		let $ibeNavList:any = $('#bookingNav li');
		let $mobIbeNav: any = $('#mab-bookingnav.mobile #bookingNav');		 
		let $errorValidationGen:any     = $('.error-validation');
		let $bookingFormTitle:any       = $('.booking-form--title');
		let $dateFormTitle:any          = $('.date-form--title');
		let $bookdateSelectorGen:any    = $('.book-date--selector');
		let $couponCodeGen:any          = $('.couponCode');
		let $redemptionLogin:any        = $('.redemption-login .form-group');

		let $bookFlightMob: any = $('#mobile-bookflight--container');		
		let $mhStayMob: any = $('#mob-stay--container');
		let $mhUpgradeMob: any = $('#mob-mhupgrade--container');		
		let $mobMholidays  : any = $('#mobile-mholidays--container');
		let $enrichHotelsMob: any 	 = $('#mobile-enrichhotels--container');

		// IBE Navigation show/hide detailed container
		$ibeNav.find('.more-links').on('click', () => {	
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.more-links').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').removeClass('mholidays-navbar');
			}			
			// desktop stuff
			_self.$scope.show();
			$checkIn.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$login.hide();
			$mholidays.hide();
			$flightUpgrade.hide();
            $loggedin.addClass('hidden');
            $bookingWidget.hide();
			$enrichHotel.hide();
			// mobile stuff
			_self.$scopeMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$flightupgradeMob.hide();
			$enrichHotelMob.hide();
			$enrichHotelsMob.hide();
			// form stuff
			$errorValidationGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$dateFormTitle.removeClass('has-error');
			$bookdateSelectorGen.removeClass('has-error');
		});	
		$('.enrich-revamp .mob-more').on('click', () => {
			$('#bookingNav li').removeClass('selected');
			$('.enrich-revamp .mob-more').parent().addClass('selected');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$flightupgradeMob.hide();
			$mobMholidays.hide();
			$mhStayMob.hide();
			$mhUpgradeMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$checkInMob.hide();
			$errorValidationGen.hide();
			$enrichHotelsMob.hide();
			$bookingFormTitle.removeClass('has-error');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header').addClass('hide');
				$('.enrich-revamp .enrich-mobile-ibe-container').removeClass('hide');			
				let targetHeight: any = $(window).innerHeight() + 'px';
				$('.enrich-revamp #more-links--container').css('height', targetHeight);					
			}
		});	
		$('.enrich-revamp .subhome-banner-viewall').on('click', () => {
			$('.enrich-revamp .mob-more').trigger('click');
		});
	}
}
let scope:Element = document.querySelector('#more-links--container');
if (scope){
	try {
		
        let morelinks = new moreLinks();
        morelinks.nav();
    } catch(e) {console.error(e);}
}

